/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { connect } from "react-redux";

const AsideMenuList = (props) => {
  const { layoutProps, auth } = props;

  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Layout/Layout-top-panel-3.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>

        <li className="menu-section ">
          <h4 className="menu-text">Menu</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/react-bootstrap",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >

            <NavLink className="menu-link menu-toggle" to="">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Settings4.svg")} />
              </span>
              <span className="menu-text">MANAGEMENT</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <li
                  className={`menu-item ${getMenuItemActive("/management/users", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/management/users">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")} />
                    </span>
                    <span className="menu-text">Users</span>
                  </NavLink>
                </li>

                {
                  auth.isAdmin &&
                  <>
                    <li
                      className={`menu-item ${getMenuItemActive("/management/clients", false)}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/management/clients">
                        <span className="svg-icon menu-icon">
                          <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Design/Color-profile.svg")} />
                        </span>
                        <span className="menu-text">Clients</span>
                      </NavLink>
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive("/management/automated-reports", false)}`}
                      aria-haspopup="true"
                    >
                      {/* <NavLink className="menu-link" to="/management/pay-rates">
                        <span className="svg-icon menu-icon">
                          <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Shopping/Dollar.svg")} />
                        </span>
                        <span className="menu-text">Pay Rates</span>
                      </NavLink> */}
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive("/management/settings", false)}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/management/settings">
                        <span className="svg-icon menu-icon">
                          <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")} />
                        </span>
                        <span className="menu-text">Settings</span>
                      </NavLink>
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive("/management/annual-quotas", false)}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/management/annual-quotas">
                        <span className="svg-icon menu-icon">
                          <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")} />
                        </span>
                        <span className="menu-text">Annual Quotas</span>
                      </NavLink>
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive("/management/automated-reports", false)}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/management/automated-reports">
                        <span className="svg-icon menu-icon">
                          <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Devices/Server.svg")} />
                        </span>
                        <span className="menu-text">Automated Reports</span>
                      </NavLink>
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive("/management/year-transition", false)}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/management/year-transition">
                        <span className="svg-icon menu-icon">
                          <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Home/Clock.svg")} />
                        </span>
                        <span className="menu-text">Year Transition</span>
                      </NavLink>
                    </li>
                    {(auth.user.username === 'admin' || auth.user.username === 'Chip') &&
                    <li
                      className={`menu-item ${getMenuItemActive("/management/year-allocation-settings", false)}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/management/year-allocation-settings">
                        <span className="svg-icon menu-icon">
                          <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Shopping/Chart-pie.svg")} />
                        </span>
                        <span className="menu-text">Cost Allocation</span>
                      </NavLink>
                    </li>
                    }
                  </>
                }
              </ul>
            </div>
          </li>
        }

        {
          auth.isAdmin &&
          <li
            className={`menu-item menu-item-submenu `}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Folder-thunder.svg")} />
              </span>
              <span className="menu-text">COMPANY DATA</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <li
                  className={`menu-item ${getMenuItemActive("/company-data/project-types", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/company-data/project-types">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")} />
                    </span>
                    <span className="menu-text">Project Types</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive("/company-data/project-sub-types", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/company-data/project-sub-types">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/General/Duplicate.svg")} />
                    </span>
                    <span className="menu-text">Project Sub Types</span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/company-data/projects", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/company-data/projects">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/General/Duplicate.svg")} />
                    </span>
                    <span className="menu-text">Projects</span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/company-data/credential-types", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/company-data/credential-types">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/General/Star.svg")} />
                    </span>
                    <span className="menu-text">Credential Types</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive("/company-data/interval-types", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/company-data/interval-types">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Home/Clock.svg")} />
                    </span>
                    <span className="menu-text">Interval Types</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive("/company-data/referral-sources", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/company-data/referral-sources">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Navigation/Exchange.svg")} />
                    </span>
                    <span className="menu-text">Referral Sources</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        }

        {/* REPLICA */}
        {
          <li
            className={`menu-item menu-item-submenu`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Protected-file.svg")} />
              </span>
              <span className="menu-text">CREDENTIALS</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {
                  auth.isAdmin &&
                  <li
                    className={`menu-item ${getMenuItemActive("/training/credentials", false)}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/training/credentials">
                      <span className="svg-icon menu-icon">
                        <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-list.svg")} />
                      </span>
                      <span className="menu-text">Credentials</span>
                    </NavLink>
                  </li>
                }
                <li
                  className={`menu-item ${getMenuItemActive("/training/user-credentials", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/training/user-credentials">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-check.svg")} />
                    </span>
                    <span className="menu-text">User Credentials</span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/training/employee-search", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/training/employee-search">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
                    </span>
                    <span className="menu-text">Employee Search</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        }
        {auth.isAdmin && 
        <li
            className={`menu-item menu-item-submenu`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Folder-star.svg")} />
              </span>
              <span className="menu-text">Reports</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <li
                  className={`menu-item ${getMenuItemActive("/training/user-credentials", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/reports/time-log-report">
                    <span className="svg-icon menu-icon">
                      <SVG className="menu-item-icon" src={toAbsoluteUrl("/media/svg/icons/Home/Timer.svg")} />
                    </span>
                    <span className="menu-text">Time Log Report</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>}
        {/* OLD MENU */}
        <>
          {/* {
          auth.isAdmin || auth.isProjectManager ?
            <>
              <li className="menu-section ">
                <h4 className="menu-text">Management</h4>
                <i className="menu-icon flaticon-more-v2"></i>
              </li>

              <li
                className={`menu-item ${getMenuItemActive("/management/users", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/management/users">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")} />
                  </span>
                  <span className="menu-text">Users</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive("/management/clients", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/management/clients">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Color-profile.svg")} />
                  </span>
                  <span className="menu-text">Clients</span>
                </NavLink>
              </li>
              {
                auth.isAdmin &&
                <>
                  <li
                    className={`menu-item ${getMenuItemActive("/management/settings", false)}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/management/settings">
                      <span className="svg-icon menu-icon">
                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")} />
                      </span>
                      <span className="menu-text">Settings</span>
                    </NavLink>
                  </li>
                  <li
                    className={`menu-item ${getMenuItemActive("/management/automated-reports", false)}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/management/automated-reports">
                      <span className="svg-icon menu-icon">
                        <SVG src={toAbsoluteUrl("/media/svg/icons/Devices/Server.svg")} />
                      </span>
                      <span className="menu-text">Automated Reports</span>
                    </NavLink>
                  </li>
                </>
              }

            </> : <></>
        } */}

          {/* {
          auth.isAdmin ?
            <>
              <li className="menu-section ">
                <h4 className="menu-text">Company Data</h4>
                <i className="menu-icon flaticon-more-v2"></i>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/company-data/project-types", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/company-data/project-types">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg")} />
                  </span>
                  <span className="menu-text">Project Types</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive("/company-data/project-sub-types", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/company-data/project-sub-types">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Duplicate.svg")} />
                  </span>
                  <span className="menu-text">Project Sub Types</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/company-data/credential-types", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/company-data/credential-types">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Star.svg")} />
                  </span>
                  <span className="menu-text">Credential Types</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive("/company-data/interval-types", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/company-data/interval-types">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Clock.svg")} />
                  </span>
                  <span className="menu-text">Interval Types</span>
                </NavLink>
              </li>

              <li
                className={`menu-item ${getMenuItemActive("/company-data/referral-sources", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/company-data/referral-sources">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Exchange.svg")} />
                  </span>
                  <span className="menu-text">Referral Sources</span>
                </NavLink>
              </li>
            </>
            : <></>
        } */}
          {/* {
          auth.isAdmin || auth.isProjectManager ?
            <>
              <li className="menu-section ">
                <h4 className="menu-text">Credentials</h4>
                <i className="menu-icon flaticon-more-v2"></i>
              </li>
              {
                auth.isAdmin &&
                <li
                  className={`menu-item ${getMenuItemActive("/training/credentials", false)}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/training/credentials">
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-list.svg")} />
                    </span>
                    <span className="menu-text">Credentials</span>
                  </NavLink>
                </li>
              }
              <li
                className={`menu-item ${getMenuItemActive("/training/user-credentials", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/training/user-credentials">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-check.svg")} />
                  </span>
                  <span className="menu-text">User Credentials</span>
                </NavLink>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/training/employee-search", false)}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/training/employee-search">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
                  </span>
                  <span className="menu-text">Employee Search</span>
                </NavLink>
              </li>
            </> : <></>
        } */}
        </>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(AsideMenuList);